import {
  GET_OPEN_PAYMENTS, RETRY_PAYMENT, PAY_OPEN_PAYMENT,
  GET_BRAINTREE_CLIENT_TOKEN, NEW_GET_OPEN_PAYMENT, NEW_GET_OPEN_PAYMENTS
} from '@/utils/store/actionTypes'
import { SET_OPEN_PAYMENTS } from '@/utils/store/mutationTypes'
import { apolloClient } from '@/utils/store'
import GetOpenPayments from '@/apollo/payment/GetOpenPayments.graphql'
import { formatData } from '@/utils/apollo'
import RetryPayment from '@/apollo/payment/RetryPayment.graphql'

export default {
  /**
   * Gets the open payments
   *
   * @param commit
   * @returns {Promise<*>}
   */
  async [GET_OPEN_PAYMENTS] ({ commit }) {
    const response = await apolloClient(this).query({
      query: GetOpenPayments,
      fetchPolicy: 'no-cache'
    })

    const openPayments = formatData(response).data

    commit(SET_OPEN_PAYMENTS, openPayments)

    return openPayments
  },

  /**
   * Retry a payment.
   *
   * @param commit
   * @param variables
   * @returns {Promise<*>}
   */
  async [RETRY_PAYMENT] (_, variables) {
    const response = await apolloClient(this).mutate({
      mutation: RetryPayment,
      variables
    })

    return this.$ota.apollo.formatData(response).data
  },
  async [GET_BRAINTREE_CLIENT_TOKEN] (_, { currency = 'EUR' }) {
    const currencyUppercase = currency.toUpperCase()
    const response = await fetch(`${process.env.BASE_S3_PATH}/api-response/braintree-client-token/${currencyUppercase}.json`)

    const json = await response.json()

    return json.token
  },
  async [NEW_GET_OPEN_PAYMENT] (_, { paymentId, _hash }) {
    let url = `${process.env.API_URL}/v2/payment/${paymentId}/payable`
    if (_hash !== undefined) {
      url = `${process.env.API_URL}/v2/payment/${paymentId}/payable?_hash=${_hash}`
    }

    const response = await this.$axios.$get(url, {
      headers: {
        ContentType: 'application/json',
        Accept: 'application/json'
      }
    })

    return response
  },
  async [PAY_OPEN_PAYMENT] (_, variables) {
    const response = await this.$axios.$post(`${process.env.API_URL}/v2/payment/${variables.paymentId}/payable/pay`,
      variables,
      {
        headers: {
          ContentType: 'application/json',
          Accept: 'application/json'
        }
      })

    return response
  },
  async [NEW_GET_OPEN_PAYMENTS] (_, { userId, _hash }) {
    const response = await this.$axios.$get(`${process.env.API_URL}/v2/users/${userId}/payments/payable${_hash ? `?_hash=${_hash}` : ''}`,
      {
        headers: {
          ContentType: 'application/json',
          Accept: 'application/json'
        }
      })

    return response
  }
}
